import { injectIntl, WrappedComponentProps } from 'react-intl'
import { useSelector } from 'react-redux'

import ActionIcon from '@components/UI/ActionIcon'
import { useModal } from '@hooks/useModal'
import { selectCampaign } from '@store/campaigns'
import { IApplicationState } from '@store/index'
import Theme from '@theme'
import { PitchComparisonModal } from './PitchComparisonModal'

interface IProps {
  highlighted?: boolean
  submissionId: number
  campaignId: number
}

export const ActionBarIconCompareSubmission = ({
  highlighted,
  intl,
  submissionId,
  campaignId,
}: IProps & WrappedComponentProps) => {
  const { showModal } = useModal()

  const campaign = useSelector((state: IApplicationState) => selectCampaign(state, campaignId))
  const isPitchingEnabled = campaign?.pitching_enabled

  const tooltipKey = isPitchingEnabled
    ? 'submission.card.action.compareSubmission'
    : 'submission.card.action.compareSubmission.nonPitch'

  const onClick = () => {
    showModal(PitchComparisonModal, { submissionId, campaignId })
  }

  return (
    <ActionIcon
      highlighted={highlighted}
      glyph="compare-submission"
      color={Theme.grey900Color}
      size={1.5}
      tooltip={intl.formatMessage({ id: tooltipKey })}
      elementName="compare"
      onClick={onClick}
    />
  )
}

export default injectIntl(ActionBarIconCompareSubmission)
